import React, { Component } from "react";
import { Row, Col, Button, DatePicker, Space } from "antd";
import { withRouter } from "react-router-dom";
import { API } from "../../API/API";
import PieChart from "../../Components/PieChart/PieChart";
import "./Home.css";
const dateFormat = "YYYY.MM.DD";
var moment = require("moment");
class Home extends Component {
  state = {
    tendercount: 0,
    invcount: 0,
    invopencount: 0,
    resultcount: 0,
    joinworkcount: 0,
    tenderTypeData: [],
    vendorSelectedData: [],
    filterYear: null,
    filterQuarter: null,
    filterMonth: null,
    filterDay: null,
    dkey: 1,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    let body = {
      year: this.state.filterYear,
      quarter: this.state.filterQuarter,
      month: this.state.filterMonth,
      day: this.state.filterDay,
    };
    API.post("getTenderCounts", body).then((response) => {
      if (response.status === 200) {
        this.setState((prevState) => ({
          tendercount: response.data.retData[0][0].tendercount,
          invcount: response.data.retData[0][0].invcount,
          invopencount: response.data.retData[0][0].invopencount,
          resultcount: response.data.retData[0][0].resultcount,
          joinworkcount: response.data.retData[0][0].joinworkcount,
          tenderTypeData: response.data.retData[1],
          vendorSelectedData: response.data.retData[2],
          dkey: prevState.dkey + 1,
        }));
      }
    });
    console.log(moment(this.state.filterQuarter, dateFormat));
  };
  onChangeYear = (date, dateString) => {
    this.setState({ filterYear: dateString });
  };
  onChangeQuarter = (date, dateString) => {
    console.log(date, dateString);
    this.setState({ filterQuarter: dateString });
  };
  onChangeMonth = (date, dateString) => {
    this.setState({ filterMonth: dateString });
  };
  onChangeDay = (date, dateString) => {
    this.setState({ filterDay: dateString });
  };
  onSearch = () => {
    this.getData();
  };
  onCallScreen = (index) => {
    if (index === 0) {
      this.props.history.push("/joinwork");
    }
    else {
      this.props.history.push("/tender/" + index);
    }
  }
  render() {
    return (
      <div key={this.state.dkey} className="mainContainer">
        <div>
          <Row gutter={(16, 16)}>
            <Col onClick={() => this.onCallScreen(1)} span={6}>
              <div className="Card" style={{ backgroundColor: "#578ebe" }}>
                <div className="Card-Header-Label">Төлөвлөгдсөн тендер</div>
                <Row justify="end">
                  <div className="Card-Content-Label">
                    {this.state.tendercount}
                  </div>
                </Row>
              </div>
            </Col>
            <Col onClick={() => this.onCallScreen(2)} span={6}>
              <div className="Card" style={{ backgroundColor: "#E87E04" }}>
                <div className="Card-Header-Label">Урилга</div>
                <Row justify="end">
                  <div className="Card-Content-Label">{this.state.invcount}</div>
                </Row>
              </div>
            </Col>
            <Col onClick={() => this.onCallScreen(3)} span={6}>
              <div className="Card" style={{ backgroundColor: "#F3C200" }}>
                <div className="Card-Header-Label">Нээлт хийх тендер</div>
                <Row justify="end">
                  <div className="Card-Content-Label">
                    {this.state.invopencount}
                  </div>
                </Row>
              </div>
            </Col>
            <Col onClick={() => this.onCallScreen(0)} span={6}>
              <div className="Card" style={{ backgroundColor: "#4DB3A2" }}>
                <div className="Card-Header-Label">Хамтран ажиллах урилга</div>
                <Row justify="end">
                  <div className="Card-Content-Label">
                    {this.state.joinworkcount}
                  </div>
                </Row>
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "20px" }} gutter={(16, 16)}>
            <Col span={3}>
              <div className="fieldLabel">Он</div>
              <DatePicker
                defaultValue={
                  this.state.filterYear
                    ? moment(this.state.filterYear, dateFormat)
                    : null
                }
                onChange={this.onChangeYear}
                style={{ width: "100%", height: 30 }}
                picker="year"
                placeholder=""
              ></DatePicker>
            </Col>
            <Col span={3}>
              <div className="fieldLabel">Улирал</div>
              <DatePicker
                defaultValue={
                  this.state.filterQuarter
                    ? moment(this.state.filterQuarter, "yyyy-QQQ")
                    : null
                }
                onChange={this.onChangeQuarter}
                style={{ width: "100%", height: 30 }}
                picker="quarter"
                placeholder=""
              ></DatePicker>
            </Col>
            <Col span={3}>
              <div className="fieldLabel">Сар</div>
              <DatePicker
                defaultValue={
                  this.state.filterMonth
                    ? moment(this.state.filterMonth, dateFormat)
                    : null
                }
                onChange={this.onChangeMonth}
                style={{ width: "100%", height: 30 }}
                picker="month"
                placeholder=""
              ></DatePicker>
            </Col>
            <Col span={3}>
              <div className="fieldLabel">Өдөр</div>
              <DatePicker
                defaultValue={
                  this.state.filterDay
                    ? moment(this.state.filterDay, dateFormat)
                    : null
                }
                onChange={this.onChangeDay}
                style={{ width: "100%", height: 30 }}
                picker="day"
                placeholder=""
              ></DatePicker>
            </Col>
            <Col span={3}>
              <Button
                type="primary"
                style={{
                  backgroundColor: "#0358A7",
                  borderRadius: 4,
                  marginTop: "22px",
                }}
                onClick={this.onSearch}
              >
                Хайх
              </Button>
            </Col>
          </Row>
          <Row style={{ marginTop: "20px" }} gutter={(16, 16)}>
            <Col span={12}>
              <div className="PieCard" style={{ backgroundColor: "#FFFFFF" }}>
                <div className="PieCard-Header-Label">
                  Зарласан тендер төрлөөр
                </div>
                <div className="PieCard-Content-Label">
                  Нийт {this.state.tendercount} тендер зарласан байна
                </div>
                <div className="PieCard-Divider"></div>
                <PieChart data={this.state.tenderTypeData} />
              </div>
            </Col>
            <Col span={12}>
              <div className="PieCard" style={{ backgroundColor: "#FFFFFF" }}>
                <div className="PieCard-Header-Label">Шалгарсан компаниуд</div>
                <div className="PieCard-Content-Label">
                  Нийт {this.state.tendercount} тендер зарласан байна
                </div>
                <div className="PieCard-Divider"></div>
                <PieChart data={this.state.vendorSelectedData} />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default withRouter(Home);
